import { FormControl, FormLabel, Input} from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateQuestionSetting } from "../../actions";

function HintFunction() {
  const { question, questionId, languages } = useSelector((state) => ({
    question: state.question_checked_settings,
    questionId: state.question_checked,
    languages: state.languages,
  }));
  const dispatch = useDispatch();
  return (
    <>
      <FormLabel component="legend" style={{color:"#000", fontWeight:"bold", fontSize:"1.2rem"}}>Question Hint</FormLabel>
      { 
        languages.map((lang) => {
          return (
            <FormControl fullWidth style={{padding:"15px"}} key={`${questionId}_hint::${lang}`}>
              <FormLabel style={{color:"#000", fontWeight: "bold"}}>
                {`Hint ${lang}:`} 
              </FormLabel>
              <Input 
                style={{marginTop:'0'}}
                id={`${questionId}_hint::${lang}`}
                onChange={(e) => {
                  dispatch(
                    updateQuestionSetting(
                      questionId,
                      `hint::${lang}`,
                      e.target.value
                    )
                  );
                }}
                value={question[`hint::${lang}`] || ''}
                // defaultValue={question[`hint::${lang}`]}
              />
            </FormControl>
          )
        })
      }
    </>
  );
}

export default HintFunction;
